import React, { useEffect, useMemo } from 'react';
import classes from './styles.module.scss';
import Layout from '../../components/Layout';
import ManualAppDownloadButton from '../../components/ManualAppDownloadButton';
import { Heading } from '@chakra-ui/layout';
import queryString from 'query-string';
import { useToast } from '@chakra-ui/toast';
import { copyToClickBoard, downloadApk } from '../../utils';
import { PLAY_STORE_URL } from '../../config';
import HeroImage from '../../assets/hero-lg.png';
import { ReactComponent as CopyIcon } from '../../assets/icons/copy.svg';
import { AttributionService } from '../../service/AttributionService';
import { UserService } from 'service/UserService';
import { useSearchParams, useLocation } from 'react-router-dom';

const CHILLAR_PRO_REFERAL = 'chillar_pro';

export default function Referral() {
  const toast = useToast();
  const [searchParams] = useSearchParams();
  let location = useLocation();
  const params = queryString.parse(location.search);
  console.log(params);

  return (
    <Layout>
      <div className={classes.Referral}>
        <div className={classes.heroContent}>
          <div className={classes.desc}>
            You are referred by <Heading as="h6"> {params.userName}</Heading>
            Download the app and use the referral code below to start earning
            extra
          </div>
          <div className={classes.ReferalCopyBlock}>
            <div className={classes.code}>{params.referralCode}</div>
            <CopyIcon
              className={classes.CopyIcon}
              onClick={() => {
                if (copyToClickBoard(params.referralCode)) {
                  toast({
                    title: 'Referral code copied!',
                    key: 'referal-code',
                    status: 'success',
                  });
                }
              }}
            />
          </div>

          <ManualAppDownloadButton
            width={'300px'}
            onClick={() => {
              copyToClickBoard(params.referralCode);
              downloadApk();
            }}
          >
            Copy Code and Download
          </ManualAppDownloadButton>
        </div>
        <div className={classes.heroImage}>
          <img src={HeroImage} />
        </div>
      </div>
    </Layout>
  );
}
